import { Injectable } from '@angular/core';
import { EntityStore } from '@examdojo/state';
import { ChallengeActivityState, ChallengeActivityStoreModel } from './challenge-activity.model';

@Injectable({ providedIn: 'root' })
export class ChallengeActivityStore extends EntityStore<ChallengeActivityState, ChallengeActivityStoreModel, 'id'> {
  constructor() {
    super({
      name: 'challenge-activities',
      idKey: 'id',
    });
  }
}
